// Permission modules — keep in sync with backend middlewares/permissions.js
export const MODULES = [
  { key: "dashboard", label: "الشاشة الرئيسية" },
  { key: "schools", label: "إدارة المدارس" },
  { key: "employees", label: "شؤون الموظفين" },
  { key: "finance", label: "الشؤون المالية" },
  { key: "holidays", label: "العطل والمناسبات" },
  { key: "tarwees", label: "ترويسة الوزارة" },
  { key: "versions", label: "إصدارات الفارس" },
  { key: "notifications", label: "التنبيهات" },
  { key: "archive", label: "الأرشيف" },
  { key: "school_notes", label: "رسائل المستخدمين" },
  { key: "whats_new", label: "ما الجديد" },
  { key: "school_constants", label: "ثوابت المدارس" },
  { key: "quick_controls", label: "مركز التحكم السريع" },
  { key: "users", label: "إدارة المستخدمين" },
  { key: "roles", label: "إدارة الأدوار" },
];

export const ACTIONS = [
  { key: "view", label: "عرض" },
  { key: "add", label: "إضافة" },
  { key: "edit", label: "تعديل" },
  { key: "delete", label: "حذف" },
];

export const moduleLabel = (key) =>
  MODULES.find((m) => m.key === key)?.label || key;
